// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"147":"c50418a2","337":"a0ec6627","453":"d7446e4a","549":"5e8c301a"}[chunkId] + ".chunk.js";
};